export default __webpack_public_path__ + "static/media/web_medium_engaged.35919a95.svg";